import getImageUrlCreatorUtil from 'pages/Creators/utils/get-image-url/index.js'
import React from 'react'

export default function RestImage (props) {
  return (
    <img
      src={getImageUrlCreatorUtil('rest.jpg')}
      alt='rest image'
      {...props}
    />
  )
}
